import { CAMPAIGN } from "../../actions/dashboard";

export default function(state = false, action) {
  switch (action.type) {
    case CAMPAIGN:
      return action.payload;
    default:
  }

  return state;
}
